import { createContext, useContext } from 'react';

export const FormLoadErrorContext = createContext(null);

export const useReportFormLoadError = () => useContext(FormLoadErrorContext);
